// A /live session's identity in the lists (LiveEvent.vue, EarlierToday.vue): its moment, not
// its text, so changing the time zone keeps every card (Seán, 2026-11-03: a zone's change set
// off the fold transition, as each card's key had the zone in it); its title and speaker too,
// as parallel sessions (the breakouts) start together
export function getSessionKey(item) {
  return `${item?.startTimeStamp?.toMillis?.()}|${item?.title}|${item?.name}`;
}
